import {
	CheckedAnswerNoneSvg,
	CheckedAnswerCorrectSvg,
	CheckedAnswerIncorrectSvg
} from "../../svg/index";

const SVGCheckedAnswer = ({ value = "none", width = 15, height = 40 }) => {
	let jsx;
	const props = { width, height };
	switch (value) {
		case "none":
			jsx = <CheckedAnswerNoneSvg {...props} />;
			break;
		case "correct":
			jsx = <CheckedAnswerCorrectSvg {...props} />;
			break;
		case "incorrect":
			jsx = <CheckedAnswerIncorrectSvg {...props} />;
			break;
		case "hide":
			jsx = <></>;
			break;
		default:
			jsx = <></>;
	}
	return jsx;
};

export default SVGCheckedAnswer;
